<template>
  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;min-height: 300px;font-size: 14px;color: #121213;text-align: center;font-weight: 400;">
    <img :style="{ width: imgWidth + 'px' }" v-if="img" :src="img" />
    <div>{{ text }}</div>
    <slot name="content"></slot>
  </div>
</template>
<style scoped>

</style>
<script>
export default {
  props: {
    imgWidth: {
      type: Number,
      default: 500
    },
    img: {
      type: String,
      default: require("@/assets/img/empty/empty.png")
    },
    text: {
      type: String,
      default: "空空如也"
    }
  }
};
</script>
